import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PageHero from '../components/PageHero';
import useReveal from '../hooks/useReveal';
import { documentationPage } from '../mock';

const Documentation = () => {
  const ref = useReveal();
  const p = documentationPage;
  return (
    <div ref={ref}>
      <PageHero eyebrow={p.eyebrow} title={p.title} image={p.image} />

      {/* INTRO */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 py-24 md:py-32 reveal">
          <p className="font-serif font-light text-2xl md:text-4xl leading-[1.4]">{p.intro}</p>
        </div>
      </section>

      {/* PROCES */}
      <section className="bg-ink text-bone">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 md:py-32">
          <div className="reveal mb-16 max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.3em] text-bone/40">{p.processEyebrow}</p>
            <h2 className="mt-5 font-serif font-light text-4xl md:text-5xl">{p.processTitle}</h2>
          </div>
          <div className="divide-y divide-bone/15 border-t border-bone/15">
            {p.steps.map((s) => (
              <div
                key={s.no}
                className="reveal grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-12 items-baseline"
              >
                <div className="md:col-span-2 font-serif text-3xl text-clay">{s.no}</div>
                <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl font-light">{s.title}</h3>
                <p className="md:col-span-6 text-sm font-light leading-relaxed text-bone/60">{s.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-bone">
        <div className="mx-auto max-w-[1100px] px-6 md:px-12 py-24 md:py-32 text-center reveal">
          <h2 className="font-serif font-light text-3xl md:text-5xl leading-tight">{p.cta.title}</h2>
          <Link
            to={p.cta.path}
            className="mt-10 inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.25em] border-b border-ink/50 pb-1 hover:border-ink transition-colors"
          >
            {p.cta.label} <ArrowRight size={14} strokeWidth={1.4} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Documentation;
